module.exports = __webpack_public_path__ + "img/energy-propose.3bd1ae5e.png";